module.exports = __webpack_public_path__ + "static/media/promotion-2.95614534.png";